import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import StepAmount from "./components/StepAmount";
import StepBeneficiary from "./components/StepBeneficiary/StepBeneficiary";
import StepReview from "./components/StepReview";
import {
  CurrentStep,
  StepContent,
  Title,
  Wrapper,
  Stepper,
  BackButton,
} from "./style";
import { ReactComponent as BackIcon } from "../../../../assets/icons/arrow-right.svg";
import { useParams } from "react-router-dom";
import { getTransferFee, getInternationalTransferFee } from "../../api";
import { formatNumber } from "../../../../utils/currency";
import { getExchangeRate } from "../../../KlashaWire/wiresAPI";
import Loader from "../../../../components/common/Loader";
import { removeLastCharacter } from "../../utils";
import {capitalizeCurrencyCode} from "../../../../utils/helpers";

type Props = {
  close: boolean;
  setClose: Dispatch<SetStateAction<boolean>>;
}

// Candidate for refactoring.

const SendFunds = ({ close, setClose }: Props) => {
  const selectedCurrency = [];
  const [current, setCurrent] = useState(0);
  const [loading, setLoading] = useState(false);
  const { currencyCode } = useParams();
  const [rate, setRate] = useState<number>();
  const [accountType, setAccountType] = useState(null);
  const [identity, setidentity] = useState(null);
  const [activeCurrency, setActiveCurrency] = useState("Same currency");
  const [internationalFee, setInternationalFee] = useState<any>("");
   const TZS = capitalizeCurrencyCode(currencyCode) === "TZS"

  // form 1
  const [destinationCurrency, setDestinationCurrency] = useState<string>(
    selectedCurrency?.length ? selectedCurrency[0] : []
  );
  const [beneficiaryReceives, setBeneficiaryReceives] = useState<number>();
  const [amount, setAmount] = useState<number>();
  const [sendSameCurrency, setSendSameCurrency] = useState<number>();
  const [sameCurrencyReceive, setSameCurrencyReceive] = useState();
  const [transferFee, setTransferFee] = useState(null);
  const currencyTab = capitalizeCurrencyCode(currencyCode);

  // form 2
  const [internationalTransfer, setInternationalTransfer] = useState(null);
  const [localBankInfo, setLocalBankInfo] = useState(null);
  const [bankName, setBankName] = useState(null);
  const [accountName, setAccountName] = useState<string>();
  const [paymentScheme, setPaymentScheme] = useState<string>();

  const countryName = removeLastCharacter(
    capitalizeCurrencyCode(currencyCode) === "ZAR" ? "SAS" : capitalizeCurrencyCode(currencyCode)
  );

  useEffect(() => {
    async function fetchtransactionFeeData() {
      try {

        let data
        if (activeCurrency === "Same currency") {
          if (countryName !== "TZ") {
            data = await getTransferFee({ country: countryName })
          } else if (countryName === "TZ" && localBankInfo !== null && sendSameCurrency >= 1000) {
            const feeType = localBankInfo.bankCode === "TZ-BANK-B2C" 
                ? "merchantBankTransferFee"
                : "MOBILEMONEYTRANSFER";

            data = await getTransferFee({
              country: countryName, 
              feeType, 
              amount: sendSameCurrency
            })
          }
          if (data) {
            setTransferFee(data)
          }
        }
    
      } catch (error) {
        return error;
      }
    }
      fetchtransactionFeeData();
  }, [activeCurrency, localBankInfo, sendSameCurrency]);

  useEffect(() => {
    async function fetchtransactionFeeData() {
      try {
        await getInternationalTransferFee({
          destinationCountry: removeLastCharacter(capitalizeCurrencyCode(destinationCurrency)),
          sourceCountry: capitalizeCurrencyCode(currencyCode),
        }).then((data) => {
          setInternationalFee(data);
        });
      } catch (error) {
        throw new Error(error)
      }
    }

    if (activeCurrency === "International" && destinationCurrency !== null) {
      fetchtransactionFeeData();
    }
  }, [destinationCurrency, currencyCode, activeCurrency]);

  const InternationalMerchantFee =
    beneficiaryReceives * (Number(internationalFee?.fees) / 100) +
    internationalFee?.cap * rate;

  const getExchangeOne = async () => {
    try {
      setLoading(true);
      const data = await getExchangeRate(
        currencyTab,
        sendSameCurrency,
        capitalizeCurrencyCode(currencyCode)
      );

      setSameCurrencyReceive(data.amount);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getExchangeTwo = async () => {
    try {
      setLoading(true);
      const data = await getExchangeRate(
        destinationCurrency,
        amount,
        capitalizeCurrencyCode(currencyCode)
      );

      setBeneficiaryReceives(data.amount);
      setRate(data.rate);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (destinationCurrency && amount >= 100 && capitalizeCurrencyCode(currencyCode)) {
      getExchangeTwo();
    }
  }, [
    destinationCurrency,
    amount,
    currencyCode,
    sendSameCurrency,
    currencyTab,
  ]);

  useEffect(() => {
    if (
      (currencyTab && sendSameCurrency >= 50) ||
      (capitalizeCurrencyCode(currencyCode) === "KES" && sendSameCurrency >= 50 && capitalizeCurrencyCode(currencyCode))
    ) {
      getExchangeOne();
    }
  }, [currencyCode, sendSameCurrency, currencyTab, sameCurrencyReceive]);

  const getRate = beneficiaryReceives / rate;

  const rateAmount = getRate || "";

  useEffect(() => {
    if (!sendSameCurrency) {
      setSameCurrencyReceive(null);
      setBeneficiaryReceives(null);
    }
  }, [sendSameCurrency]);

  useEffect(() => {
    if (activeCurrency === "Same currency") {
      setAmount(null);
      setDestinationCurrency(null);
    }

    if (activeCurrency === "International") {
      setSendSameCurrency(null);
    }
  }, [activeCurrency]);

  const InternationalTransferAmount =
    activeCurrency === "International"
      ? destinationCurrency + " " + formatNumber(amount)
      : "";

  const TotalInternationalTransferAmount =
    activeCurrency === "International"
      ? (beneficiaryReceives + InternationalMerchantFee).toLocaleString(
          undefined,
          {
            style: "currency",
            currency: capitalizeCurrencyCode(currencyCode),
          }
        )
      : "";

  const LocalBankTransferAmount =
    activeCurrency !== "International"
      ? +sendSameCurrency?.toLocaleString(undefined, {
          style: "currency",
          currency: capitalizeCurrencyCode(currencyCode) || "NGN",
        })
      : "";

  const TotalLocalBankAmount =
    activeCurrency !== "International"
      ? (Number(sendSameCurrency) + Number(transferFee?.fees)).toLocaleString(
          undefined,
          {
            style: "currency",
            currency: capitalizeCurrencyCode(currencyCode) || "NGN",
          }
        )
      : "";

  const AccountNumber =
    localBankInfo?.accountNumber || internationalTransfer?.accountNumber;
  const Beneficiary = accountName || internationalTransfer?.accountName;

  const steps = [
    {
      title: "Amount",
      header: "How much do you want to send?",
      content: (
        <StepAmount
          amount={amount}
          transferFee={transferFee}
          destinationCurrency={destinationCurrency}
          onNext={() => next()}
          fundsFromSameCurrency={sendSameCurrency}
          setFundsFromSameCurrency={setSendSameCurrency}
          currencyTab={currencyTab}
          sameCurrencyReceive={sameCurrencyReceive}
          transactionrate={rateAmount}
          activeCurrency={activeCurrency}
          setActiveCurrency={setActiveCurrency}
          setLocalBankInfo={setLocalBankInfo}
          localBankInfo={localBankInfo}
          setBankName={setBankName}
        />
      ),
    },
    {
      title: "Beneficiary",
      header: "Enter beneficiary bank details",
      content: (
        <StepBeneficiary
          identity={identity}
          setidentity={setidentity}
          accountType={accountType}
          setAccountType={setAccountType}
          activeCurrency={activeCurrency}
          onNext={() => next()}
          basicInfo={internationalTransfer}
          setBasicInfo={setInternationalTransfer}
          localBankInfo={localBankInfo}
          setLocalBankInfo={setLocalBankInfo}
          setBankName={setBankName}
          accountName={accountName}
          setAccountName={setAccountName}
          setSelectedPaymentScheme={setPaymentScheme}
        />
      ),
    },
    {
      title: "Review",
      header: "Review the details of your transfer",
      content: (
        <StepReview
          phoneNumber={localBankInfo?.phoneNumber}
          recipientAddress={localBankInfo?.recipientAddress}
          recipientEmail={localBankInfo?.recipientEmail}
          onGoBack={setCurrent}
          receipientAmount={
            InternationalTransferAmount || LocalBankTransferAmount
          }
          totalAmount={TotalInternationalTransferAmount || TotalLocalBankAmount}
          description={localBankInfo?.description}
          beneficiary={Beneficiary || localBankInfo?.zarAccountName}
          exchangeRate={
            activeCurrency === "Same currency"
              ? transferFee?.fees
              : InternationalMerchantFee.toFixed(2)
          }
          accountNumber={
            AccountNumber ||
            localBankInfo?.phone ||
            localBankInfo?.zarAccountNumber
          }
          currency={destinationCurrency}
          amount={beneficiaryReceives || sendSameCurrency}
          bankCode={localBankInfo?.bankCode}
          bankName={bankName || internationalTransfer?.sortCode}
          close={close}
          setClose={setClose}
          activeCurrency={activeCurrency}
          internationalAccountDetails={internationalTransfer}
          scheme={paymentScheme}
          bic={localBankInfo?.bic}
          serviceCode={localBankInfo?.serviceCode}
        />
      ),
      icon: "",
    },
  ];

  const next = async () => {
    if (current < steps.length - 1) setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };
  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));

  return (
    <Wrapper>
      <Loader isLoading={loading} />
      <Stepper current={current} items={items} />

      <div>
        {current > 0 && (
          <BackButton onClick={() => prev()}>
            <BackIcon />
          </BackButton>
        )}
        <StepContent>
          <Title>{steps[current].header}</Title>
          <CurrentStep>{steps[current].content}</CurrentStep>
        </StepContent>
      </div>
    </Wrapper>
  );
};

export default SendFunds;
